let _ = t => t,
  _t;
import { rotate360 } from '@ovpn-ui/styles';
import { css } from 'styled-components';
const loaderSize = '1.48571429em';
export default function loader(color, size = loaderSize) {
  return css(_t || (_t = _`
        position: relative;

        pointer-events: none !important;

        span {
            color: transparent !important;

            user-select: none !important;
        }

        &:before,
        &:after {
            position: absolute;
            top: 50%;
            left: 50%;

            width: ${0};
            height: ${0};
            margin-top: calc(-${0} / 2);
            margin-right: 0;
            margin-bottom: 0;
            margin-left: calc(-${0} / 2);

            border: 2px solid currentColor;
            border-radius: 500rem;

            content: '';
        }

        &:before {
            border-color: ${0};
            opacity: 0.3;
        }

        &:after {
            border-color: ${0} ${0} ${0} transparent;

            box-shadow: 0 0 0 1px transparent;

            animation: ${0} 0.6s linear;
            animation-iteration-count: infinite;
        }
    `), size, size, size, size, color, color, color, color, rotate360());
}